import React from 'react';
import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';
import { useObserver } from 'mobx-react';

import {
  CheckoutBody,
  CheckoutLabel,
  CheckoutLabelGrouping,
  CheckoutSectionHeading,
} from 'checkout/components/styles/common';
import useStores from 'shared/hooks/use-stores';
import { MuiAccordion, MuiAccordionSummary } from 'shared/components/accordion';
import { SummaryText } from 'checkout/components/sections/user/customer';

export function ExternalUser() {
  const { User } = useStores();
  const userEmail = useObserver(() => User.userDetailsFromExternalSource.email);

  return (
    <CheckoutLabelGrouping id='customer' data-cy='customer-card' data-test='customer-card'>
      <CheckoutLabel card>
        <CheckoutSectionHeading>Customer</CheckoutSectionHeading>
      </CheckoutLabel>
      <CheckoutBody>
        <StyledPaper>
          <SummaryText fontSize={13} color='#5d666d' mt='1px'>
            Logged in as <span>{userEmail}</span>
          </SummaryText>
        </StyledPaper>
      </CheckoutBody>
    </CheckoutLabelGrouping>
  );
}

const StyledPaper = styled(Paper)`
  height: ${MuiAccordionSummary.root.height};
  max-width: ${MuiAccordion.root.maxWidth}px;
  border: ${MuiAccordion.root.border} ${MuiAccordion.root.borderColor};
  box-shadow: ${MuiAccordion.root.boxShadow} !important;
  padding: ${MuiAccordionSummary.root.padding};

  display: flex;
  align-items: center;
`;
